import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--data-table"
// Expandable rows (CONEK-5152): toggles the sibling panel <tr> next to a row,
// updates aria-expanded on the trigger, and rotates the chevron. Keyboard
// activation (Enter/Space) comes for free from the native <button> trigger.
export default class extends Controller {
  toggleRowExpansion(event) {
    const button = event.currentTarget
    const row = button.closest("tr")
    if (!row) return

    const panel = row.nextElementSibling
    if (!panel || !panel.hasAttribute("data-expansion-panel")) return

    const willExpand = panel.classList.contains("hidden")
    panel.classList.toggle("hidden", !willExpand)
    button.setAttribute("aria-expanded", willExpand ? "true" : "false")

    const chevron = button.querySelector("[data-chevron]")
    if (chevron) chevron.classList.toggle("rotate-90", willExpand)
  }
}
